import { useCallback } from "react";
import { useAppContext } from "../../../AppContext";

export interface IGoogleAuthOptions {
  onSuccess?: () => void;
  onError?: (error: string) => void;
  returnUrl?: string;
}

export const useGoogleAuth = () => {
  const { selectedStudio } = useAppContext();

  const initiateGoogleLogin = useCallback(
    (options: IGoogleAuthOptions = {}) => {
      if (!selectedStudio?.id) {
        console.error("No temp studio available for Google authentication");
        options.onError?.("Studio information not available");
        return;
      }

      if (selectedStudio.disableGoogleLogin) {
        options.onError?.("Входът с Google е деактивиран за този обект.");
        return;
      }

      try {
        // Get the FULL source domain including port
        const sourceDomain = window.location.host;

        // Get OAuth base URL from environment
        const oauthBaseUrl = import.meta.env.VITE_GOOGLE_OAUTH_BASE_URL;

        if (!oauthBaseUrl) {
          console.error("VITE_GOOGLE_OAUTH_BASE_URL is not configured");
          options.onError?.("OAuth configuration missing");
          return;
        }

        // Build the OAuth URL with optional return URL
        let oauthUrl = `${oauthBaseUrl}/oauth/google?studioId=${selectedStudio.id}&sourceDomain=${sourceDomain}`;

        if (options.returnUrl) {
          // Also include it as URL parameter for backend
          const encodedReturnUrl = encodeURIComponent(options.returnUrl);
          oauthUrl += `&returnUrl=${encodedReturnUrl}`;
          
        }

        // Redirect to OAuth domain
        window.location.href = oauthUrl;
      } catch (error) {
      }
    },
    [selectedStudio]
  );

  const isGoogleAuthAvailable = useCallback(() => {
    return !!selectedStudio?.id && !selectedStudio.disableGoogleLogin;
  }, [selectedStudio]);

  return {
    initiateGoogleLogin,
    isGoogleAuthAvailable,
  };
};
